(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-two-columns"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
   const swiperEl = document.querySelector('.best-seller-wrap .swiper-container');
  if (!swiperEl || !swiperEl.swiper) return;
  const swiper = swiperEl.swiper;
  const buttons = document.querySelectorAll('.best-seller-wrap .buttons-best-seller-wrap a');
  swiper.on('slideChange', () => {
    buttons.forEach(element => {
      element.classList.remove("active");
    });
    buttons[swiper.realIndex].classList.add("active");
  });
});


  } catch(e) { console.error(e); }
})();
})();
